import React, { forwardRef } from 'react';

import MUITableCell, {
  TableCellProps as MUITableCellProps,
} from '@material-ui/core/TableCell';

export interface TableCellProps extends MUITableCellProps {}

const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>(
  (props, ref) => {
    return <MUITableCell {...props} ref={ref} />;
  }
);

export default TableCell;
